import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { rpcBrowserClient } from '@no0dles/hsr-browser-rpc/rpc-browser-client';
import type { rpcApp } from '@api-rpc';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  rpcClient = rpcBrowserClient<typeof rpcApp>(environment.apiBaseUrl);
}
